import { Routes } from '@angular/router';
import { authGuard, notOutageGuard, outageGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: "error",
    redirectTo: "unauthorised",
    pathMatch: "full"
  },
  {
    path: 'admin',
    loadComponent: () => import('./admin/admin.component').then((c) => c.AdminComponent),
    canActivate: [authGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [authGuard],
  },
  {
    path:'invoicing',
    loadChildren:() => import('./invoices/invoices.module').then((c) => c.InvoicesModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
  },
  {
    path: 'plans',
    loadChildren: () => import('./plan/plan.module').then((m) => m.PlanModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
  },
  {
    path: 'debug',
    loadComponent: () => import('./base/components/debug/debug.component').then((m) => m.DebugComponent),
    canActivate: [authGuard],
  },
  {
    path: 'sign-off-response',
    loadComponent: () => import('./base/components/sign-off-response/sign-off-response.component').then((m) => m.SignOffResponseComponent),
    canActivate: [authGuard],
  },
  {
    path: 'public-sign-off-response',
    loadComponent: () => import('./base/components/public-sign-off-response/public-sign-off-response.component').then((m) => m.PublicSignOffResponseComponent),
    canActivate: [notOutageGuard],
  },
  {
    path: 'unauthorised',
    loadComponent: () => import('./base/components/unauthorised/unauthorised.component').then((m) => m.UnauthorisedComponent),
    canActivate: [notOutageGuard],
  },
  {
    path: 'outage',
    loadComponent: () => import('./base/components/outage/outage.component').then((m) => m.OutageComponent),
    canActivate: [outageGuard],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
